import { createSelector, createStructuredSelector } from 'reselect';

import { Route } from '@mews-distributor/common';
import { createHandler } from '@mews/std';

import { getCurrentRoute, getPreviousRoute, hasAppInitializationFailed } from '../../modules/app/selectors';
import { getTransitionKey } from './getTransitionKey';
import { withOffset, withoutOffset } from './routerElementHeight';

const getTransition = createSelector(getCurrentRoute, getPreviousRoute, (currentRoute, previousRoute) =>
    // @ts-expect-error $TSFixMeError: Argument of type 'Route | undefined' is not assignable to parameter of type 'Route'.
    getTransitionKey(currentRoute, previousRoute)
);

const offsetHandler = createHandler(
    {
        [Route.Dates]: withOffset,
        [Route.Properties]: withOffset,
        [Route.SpaceCategories]: withOffset,
        [Route.Rates]: withOffset,
        [Route.Summary]: withOffset,
        [Route.Checkout]: withOffset,
        [Route.Confirmation]: withoutOffset,
    },
    // @ts-expect-error $TSFixMeError: Argument of type '() => { mobileHeight: string; desktopHeight: string; }' is not assignable to parameter of type '{ mobi...
    () => withOffset
);

const getRouterElementHeight = createSelector(getCurrentRoute, (currentRoute) => offsetHandler(currentRoute));

// @ts-expect-error $TSFixMeError: No overload matches this call.
export const viewMapper = createStructuredSelector({
    hasAppFailed: hasAppInitializationFailed,
    currentRoute: getCurrentRoute,
    transition: getTransition,
    menuHeight: getRouterElementHeight,
});
